/**
 * Identificador de este dispositivo/navegador para el historial de accesos.
 *
 * Se genera una vez al azar y queda en localStorage: el mismo navegador manda
 * siempre el mismo, así se puede ver "entró desde un dispositivo nuevo". No
 * identifica a la persona ni lleva datos del equipo; borrar los datos del sitio
 * genera uno nuevo.
 */
const CLAVE = 'hyf_device_id';

function generar() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
    }
    if (window.crypto && window.crypto.getRandomValues) {
        const bytes = new Uint8Array(16);
        window.crypto.getRandomValues(bytes);
        return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    }
    return `${Date.now().toString(16)}${Math.random().toString(16).slice(2, 18)}`;
}

export function getDeviceId() {
    try {
        let id = localStorage.getItem(CLAVE);
        if (!id || !/^[A-Za-z0-9-]{8,64}$/.test(id)) {
            id = generar();
            localStorage.setItem(CLAVE, id);
        }
        return id;
    } catch (e) {
        // Navegación privada sin localStorage: se manda uno de un solo uso.
        return generar();
    }
}
